export function checkStatusCode(response) {
    if (response.status == 403) {
        throw {
            error: true,
            status: 403,
        }
    }
}